<template>
    <div class="border-0 w-full" v-bind:class="$attrs.class">
        <input-label v-if="label">{{label}}</input-label>
        <input
            ref="input"
            class="w-full border border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 shadow-sm text-xs"
            v-bind="inputAttrs"
            v-model="formatedValue"
            :type="type"
            :style="sizes[size]"
        >
        <input-error :message="error"/>
    </div>
</template>

<script>
import InputLabel from "@/Components/Label";
import InputError from "@/Components/InputError";
import moment from "moment/moment";

export default {
    inheritAttrs: false,
    components: {
        InputLabel,
        InputError,
    },
    props: {
        label: String,
        modelValue: String|Number,
        error: String,
        type: {
            type: String,
            default: 'text',
        },
        size: {
            type: String,
            default: 'base',
        }
    },
    computed: {
        inputAttrs() {
            const { _, ...attrs } = this.$attrs;
            delete attrs.class;
            return attrs;
        },
        formatedValue: {
            get() {
                if (this.type === "datetime-local" && this.modelValue) {
                    return moment.utc(this.modelValue).format("YYYY-MM-DDTHH:mm");
                } else if (this.type === "date" && this.modelValue) {
                    return moment.utc(this.modelValue).format("YYYY-MM-DD");
                }
                return this.modelValue;
            },
            set(newValue) {
                if (this.type === "datetime-local") {
                    newValue = moment(newValue).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
                }

                this.$emit("update:modelValue", newValue);
            },
        },
    },
    data () {
        return {
            sizes: {
                xs: {
                    'padding-top': '.2rem',
                    'padding-bottom': '.2rem',
                    'padding-left': '.5rem',
                    'padding-right': '.5rem',
                },
                base: {
                    'padding-top': '0.625rem',
                    'padding-bottom': '0.625rem',
                    'padding-left': '1rem',
                    'padding-right': '1rem',
                    'border-radius': '0.25rem',
                },
            }
        }
    },
}
</script>
